module.exports = __webpack_public_path__ + "static/img/skyline-bg-cloud.f1377c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-bg-cloud.png
// module id = 678
// module chunks = 64